<div *ngIf="isAuthorised">
    <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
    <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
    <div class="ia-action-div" *ngIf="currentUserRole === 'Compliance Enterprise' || isSavedPermission">
        <span class="cursor-pointer text-primary ml-2 pull-right" *ngIf="filterType !== 'version'"
            (click)="updateImpactAssessment()"><i class="fa fa-floppy-o text-dark"></i>
            Save</span>
        <span class="cursor-pointer text-primary pull-right ml-2" (click)="openDialog()"><i
                class="fa fa-history text-dark"></i> Version History</span>
        <span (click)="backToCurrentVersion()" *ngIf="filterType === 'version'"
            class="cursor-pointer text-primary pull-right ml-2"><i class="fa fa-undo text-dark"></i>
            Current Version</span>
        <span class="cursor-pointer text-primary ml-2 pull-right"
            *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADC') && !impactAssessment.isMerged"
            (click)="openRegulationDialog()"><i class="fa fa-times-circle text-dark"></i> Close Assessment</span>
        <span class="cursor-pointer text-primary ml-2 pull-right"
            *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADC') && impactAssessment.isMerged"
            (click)="openBulkCloseDialog()"><i class="fa fa-times-circle text-dark"></i> Close Assessment</span>
        <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADSN')"
            class="cursor-pointer text-primary pull-right ml-2">
            <i class="fa fa-square-o icon-font vertical-align-middle"
                (click)="impactAssessment.isSendNotification = true" *ngIf="!impactAssessment.isSendNotification"
                aria-hidden="true"></i>
            <i class="fa fa-check-square icon-font vertical-align-middle"
                (click)="impactAssessment.isSendNotification = false" *ngIf="impactAssessment.isSendNotification"
                aria-hidden="true"></i>
            Send Notification
        </span>
        <span *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADRT')"
            class="cursor-pointer text-primary pull-right ml-2">
            <i class="fa fa-square-o icon-font vertical-align-middle" (click)="impactAssessment.isRecordTime = true"
                *ngIf="!impactAssessment.isRecordTime" aria-hidden="true"></i>
            <i class="fa fa-check-square icon-font vertical-align-middle"
                (click)="impactAssessment.isRecordTime = false" *ngIf="impactAssessment.isRecordTime"
                aria-hidden="true"></i>
            Record Time
        </span>
        <span class="cursor-pointer text-primary pull-right ml-2"
            *ngIf="filterType !== 'version' && commonService.checkPlanTypeAction('IADER')" (click)="downloadReport()"><i
                class="fa fa-download text-dark"></i> Export Report</span>
        <span class="mb-2 text-muted" *ngIf="checkSibling(impactAssessmentId, 'Next')">
            <span class="text-primary float-left" (click)="getSiblings('Next')">Next</span>
        </span>
        <span class="mb-2 text-muted" *ngIf="checkSibling(impactAssessmentId, 'Previous')">
            <span class="text-primary float-left ml-4" (click)="getSiblings('Previous')">Previous</span>
        </span>

    </div>
    <div class="pl-2 ia-details-div" cdkScrollable>
        <mat-accordion id="SummaryDetails">
            <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
                <mat-expansion-panel-header class="ia-mat-panel">
                    <mat-panel-title>
                        <span class="text-header inc-f">
                            Summary Details
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mr-0 ml-0" *ngIf="impactAssessment.isMerged">
                    <span class="ml-4 mr-3"><label class="control-label fw inline-block">Assessment Id </label></span>
                    <a>
                        <span *ngFor="let item of impactAssessment.merged_Id|stringToArray;"
                            (click)="getUpdatedDbInfo(item)">
                            <span
                                [ngClass]="this.impactAssessment.updatedDB_Id == item ?  'parent-id':'link-id d-inline-block'">{{item}}<span
                                    class="cursor-pointer ml-1"
                                    *ngIf="this.impactAssessment.updatedDB_Id != item && (currentUserRole === 'Compliance Enterprise' || isSavedPermission)"
                                    (click)="updateOtherMergedId(item)"><i
                                        class="fa fa-times-circle text-white"></i></span></span>
                        </span>
                    </a>
                    <span class="parent-span">
                        <label class="control-label fw mr-2 inline-block"> Parent Id </label>
                        <span *ngIf="!isParentIdEdit"
                            class="control-label inline-block">{{impactAssessment.updatedDB_Id}}</span>
                        <span *ngIf="!isParentIdEdit" class="cursor-pointer text-primary ml-2"
                            (click)="updateParentId()">
                            Edit</span>
                        <span *ngIf="isParentIdEdit" class="inline-block">
                            <select class="form-control form-control-sm" [(ngModel)]="parentId">
                                <option *ngFor="let item of impactAssessment.merged_Id|stringToArray;" value="{{item}}">
                                    {{item}}
                                </option>
                            </select>
                        </span>
                        <span *ngIf="isParentIdEdit" class="cursor-pointer text-primary ml-2"
                            (click)="changeParentId()">Confirm
                        </span>
                    </span>
                </div>
                <div class="row form-group ml-2 mt-1">
                    <div class="col-lg-2 col-md-1 mx-width-10pr">
                        <label class="control-label fw"> {{ impactAssessment.isMerged? "Id":"Assessment Id" }}</label>
                        <div class="control-label" name="ids">{{ this.currentinfoId }}</div>
                    </div>
                    <div class="col-lg-5 col-md-5 mx-width-40pr">
                        <label class="control-label fw">Title</label>
                        <div class="control-label div-scroll" name="title">{{ impactAssessment.title }}</div>
                    </div>
                    <div class="col-lg-2 mx-width-11pr">
                        <label class="control-label fw">Type</label>
                        <div class="control-label" name="title">{{ impactAssessment.pubType }}</div>
                    </div>
                    <div class="col-lg-1 mx-width-8pr">
                        <label class="control-label fw">Geography</label>
                        <div class="control-label">{{impactAssessment.geography}}</div>
                    </div>
                    <div class="col-lg-2 mx-width-8pr">
                        <label class="control-label fw">Country</label>
                        <div class="control-label">{{impactAssessment.country}}</div>
                    </div>
                    <div class="col-lg-1 mx-width-8pr">
                        <label class="control-label fw">Regulator</label>
                        <div class="control-label">{{impactAssessment.regulator}}</div>
                    </div>
                    <div class="col-lg-1 mx-width-8pr">
                        <label class="control-label fw">Date</label>
                        <div class="control-label">{{impactAssessment.updatedDB_Date | date: 'dd-MMM-yyyy' }}</div>
                    </div>
                    <div class="col-lg-1 mx-width-7pr"
                        *ngIf="impactAssessment.isRecordTime && commonService.checkPlanTypeAction('IADRT')">
                        <label class="control-label fw">Time Spent </label>
                        <div class="control-label">{{impactAssessment.timeSpent | minToHour}}</div>
                    </div>
                </div>

                <div class="row ml-2">
                    <div class="col-lg-9">
                        <div class="row">
                            <div class="col-lg-9 fw">
                                <label class="control-label fw">Description</label>
                            </div>
                            <div class="col-lg-3" *ngIf="impactAssessment.hyperlink">
                                <a href="{{impactAssessment.hyperlink}}" class=" pull-right" target="_blank">
                                    <i class="fa fa-globe"></i>
                                    <span class="text-primary cursor-pointer">
                                        Source Link</span>
                                </a>
                            </div>
                            <div class="col-lg-3" *ngIf="!impactAssessment.hyperlink">
                                <span class="pull-right"><i class="fa fa-globe"></i><span> Source Link</span></span>
                            </div>
                            <div class="col-lg-12 edit_status_changeViewer_group">
                                <div class="edit_status_changeViewer_group"
                                    *ngIf="impactAssessment.description && impactAssessment.description.indexOf('<div') < 0">
                                    <mat-form-field class="disableText w-100">
                                        <textarea matInput [(ngModel)]="impactAssessment.description"
                                            class="text-area-css" cdkTextareaAutosize disabled
                                            [innerHTML]="impactAssessment.description"></textarea>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-12 desc-text-box"
                                    *ngIf="impactAssessment.description && impactAssessment.description.indexOf('<div') >= 0">
                                    <div [innerHtml]="impactAssessment.description"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 desc-text-box" *ngIf="currentinfoId > 0">
                        <app-current-action [userId]="userAccessToken.userId" [itemId]="currentinfoId"
                            [closedType]="'Assess'">
                        </app-current-action>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion id="AdditionalDetails">
            <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2 mt-2">
                <mat-expansion-panel-header class="ia-mat-panel">
                    <mat-panel-title>
                        <span class="text-header inc-f">
                            Additional Details
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row align-items-center ml-2 mt-1">
                    <div class="col-lg-2">
                        <label class="control-label fw">Division</label>
                        <ng-select disabled *ngIf="searchedJuris.length > 0" [items]="searchedJuris" bindLabel="name"
                            appendTo="body" [multiple]="true" [(ngModel)]="selectedJuris">
                        </ng-select>
                    </div>


                    <!-- <div class="col-lg-2">
                        <label class="control-label fw">Rule Type</label>
                        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.ruleType">
                            <option *ngFor="let option of ruleType" value="{{option}}">{{option}}</option>
                        </select>
                    </div> -->
                    <div class="col-lg-2">
                        <label class="control-label fw">Effective Date</label>
                        <div class="input-group input-group-sm">
                            <input matInput [matDatepicker]="picker" (click)="picker.open()"
                                class="form-control form-control-sm border-bottom" name="applicationDate"
                                [(ngModel)]="impactAssessment.applicationDate">
                            <div class="input-group-append">
                                <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
                            </div>
                        </div>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                    <div class="col-lg-2">
                        <button class="btn bg-g-lightGreen btn-sm" (click)="openLADialog()">Linked Assessments</button>
                        <div class="mt-1" *ngIf="impactAssessment.previousImpactAsss_Id">
                            <div class="link-div mb-1" *ngFor="let linkedAId of linkedAssessmentIds">
                                <a class="link-id" (click)="openLinkedAssessment(linkedAId.id)"
                                    *ngIf="!linkedAId.isMerged">{{linkedAId.updatedDbId}}</a>
                                <a class="link-id" (click)="openLinkedAssessment(linkedAId.id)"
                                    *ngIf="linkedAId.isMerged">{{linkedAId.merged_Id}}</a>
                            </div>
                        </div>
                    </div>

                    <!-- Line of Business removed from template 1 - Amit Madahar 30 May 2023-->
                    <!-- <div class="col-lg-6 mt-1"  *ngIf="impactAssessment.templateNo==2 || impactAssessment.templateNo==1"> -->

                </div>

                <div class="row ml-2 mt-1">
                    <div class="col-lg-1">
                        <div>
                            <label class="control-label mx-auto fw">Topic</label>
                        </div>

                        <label class="cursor-pointer text-primary" (click)="deleteAllTopic()">Delete All</label>
                    </div>
                    <div class="col-lg-11 topic-list">
                        <mat-chip-grid #topicList class="myChip">
                            <mat-chip-row *ngFor="let TopicItemName of myTopicDD" [selectable]="selectable"
                                [removable]="removable" (removed)="removeTopic(TopicItemName)">
                                {{TopicItemName}}
                                <mat-icon matChipRemove *ngIf="removable && isADetailPermission"
                                    class="clear-icons">clear
                                </mat-icon>
                            </mat-chip-row>
                            <input
                                class="form-control form-control-sm mat-autodd-input border-bottom display-inline w-300px"
                                #trigautoTopic="matAutocompleteTrigger" (keydown)="getFilteredData('Topic', $event)"
                                #topicInput [formControl]="searchTopicCntrl" [matAutocomplete]="topicAutoComplete"
                                [matChipInputFor]="topicList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                                (matChipInputTokenEnd)="addTopic($event)">
                        </mat-chip-grid>
                        <mat-autocomplete #topicAutoComplete="matAutocomplete"
                            (optionSelected)="selectedTopicEvent($event)">
                            <mat-option *ngFor="let item of searchedTopics" [value]="item.value">
                                {{item.name}}
                            </mat-option>
                        </mat-autocomplete>

                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div>
            <!-- <app-progress-bar [isLoading]="isLoadingDD"></app-progress-bar> -->
            <mat-accordion id="AssessmentDetails">
                <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2 mt-2">
                    <mat-expansion-panel-header class="ia-mat-panel">
                        <mat-panel-title>
                            <span class="text-header inc-f">
                                Assessment Details
                            </span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row ml-2 my-4" [ngClass]="{ 'div-disabled': !isAssessmentAccessable}">
                        <div class="col-lg-4">
                            <label class="control-label fw">Assessment Team</label>
                            <input type="text" class="form-control form-control-sm"
                                [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                                (keyup)="updateSectionLastEdited('AssessmentTeam')"
                                [(ngModel)]="impactAssessment.assessmentTeam">
                        </div>
                        <div class="col-lg-4">
                            <label class="control-label fw">Assessor</label>
                            <mat-chip-grid #assessorList>
                                <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable"
                                    [removable]="removable" (removed)="removeAssessor(assessor)">
                                    {{assessor}}
                                    <mat-icon matChipRemove *ngIf="removable && isADetailPermission"
                                        class="clear-icons">clear
                                    </mat-icon>
                                </mat-chip-row>
                                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                                    #trigautoAssessor="matAutocompleteTrigger"
                                    (keydown)="getFilteredData('Assessor', $event)"
                                    [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                                    [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                                    [matChipInputFor]="assessorList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                                    (matChipInputTokenEnd)="addAssessor($event)">
                            </mat-chip-grid>
                            <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                                (optionSelected)="selectedAssessorEvent($event)">
                                <mat-option *ngFor="let assessor of searchedAssessor" [value]="assessor.value">
                                    {{assessor.name}}
                                </mat-option>
                            </mat-autocomplete>
                        </div>

                    </div>

                    <div class="col-lg-12" [ngClass]="{ 'div-disabled': !isAssessmentAccessable}">
                        <div>
                            <div class="header-text">

                                <span class="control-label fw">
                                    Summary
                                </span>
                            </div>


                            <app-ck-editor [(childVariable)]="impactAssessment.summary" id="implementationDetails"
                                [data]="impactAssessment.summary"
                                (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                            <!-- <ckeditor [editor]="Editor" id="implementationDetails" class="f-16" *ngIf="isIDetails"
                      [(ngModel)]="impactAssessment.implementationDetails"
                      (keyup)="updateSectionLastEdited('Implementation')">
                    </ckeditor> -->
                        </div>
                    </div>


                    <div class="col-lg-12" [ngClass]="{ 'div-disabled': !isAssessmentAccessable}">
                        <div>
                            <div class="header-text">

                                <span class="control-label fw">
                                    Intial Impact Assessment
                                </span>
                            </div>


                            <app-ck-editor [(childVariable)]="impactAssessment.initialImpactAssessment"
                                id="implementationDetails" [data]="impactAssessment.initialImpactAssessment"
                                (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                            <!-- <ckeditor [editor]="Editor" id="implementationDetails" class="f-16" *ngIf="isIDetails"
                          [(ngModel)]="impactAssessment.implementationDetails"
                          (keyup)="updateSectionLastEdited('Implementation')">
                        </ckeditor> -->
                        </div>
                    </div>

                    <div class="row ml-2 mt-1" [ngClass]="{ 'div-disabled': !isAssessmentAccessable}">
                        <div class="col-lg-3">
                            <label class="control-label fw">
                                Assessor Impact Rating
                                <span class="label label-default bg-default p5-20"
                                    *ngIf="!impactAssessment.assessorImpactRating">None</span>
                                <span class="label label-default bg-red p5-20"
                                    *ngIf="impactAssessment.assessorImpactRating === 'Very High'">Very
                                    High</span>
                                <span class="label ml-2 label-default bg-orange p5-20"
                                    *ngIf="impactAssessment.assessorImpactRating === 'High'">High</span>
                                <span class="label ml-2 label-default bg-yellow p5-20"
                                    *ngIf="impactAssessment.assessorImpactRating === 'Medium'">Medium</span>
                                <span class="label ml-2 label-default bg-green p5-20"
                                    *ngIf="impactAssessment.assessorImpactRating === 'Low'">Low</span>
                            </label>
                            <select class="form-control form-control-sm"
                                [(ngModel)]="impactAssessment.assessorImpactRating">
                                <option value="Low">Low</option>
                                <option value="Medium">Medium</option>
                                <option value="High">High</option>
                                <option value="Very High">Very High</option>
                            </select>
                        </div>
                        <div class="col-lg-3">
                            <label class="control-label fw">Assessment Due Date</label>
                            <div class="input-group input-group-sm">
                                <input matInput [matDatepicker]="assessmentDueDate"
                                    [attr.disabled]="!isRDetailPermission ? 'disabled' : null"
                                    (click)="assessmentDueDate.open()"
                                    class="form-control form-control-sm border-bottom"
                                    [(ngModel)]="impactAssessment.assessmentDueDate" name="assessmentDueDate"
                                    (dateInput)="updateSectionLastEdited('Review')" />
                                <div class="input-group-append">
                                    <span class="input-group-text fa fa-calendar" *ngIf="isRDetailPermission"
                                        (click)="assessmentDueDate.open()"></span>
                                    <span class="input-group-text fa fa-calendar" *ngIf="!isRDetailPermission"></span>
                                </div>
                            </div>
                            <mat-datepicker #assessmentDueDate></mat-datepicker>
                        </div>
                        <!-- <div class="col-lg-2">
                            <button class="btn bg-g-lightGreen btn-sm" (click)="openImpactRating()">
                                Impact Rating Detail</button>
                            <div class="mt-1">
                                <span class="label label-default bg-default p5-20"
                                    *ngIf="!impactAssessment.impactRating">Not
                                    Performed</span>
                                <span class="label label-default bg-red p5-20"
                                    *ngIf="impactAssessment.impactRating === 'Very High'">Very
                                    High</span>
                                <span class="label ml-2 label-default bg-orange p5-20"
                                    *ngIf="impactAssessment.impactRating === 'High'">High</span>
                                <span class="label ml-2 label-default bg-yellow p5-20"
                                    *ngIf="impactAssessment.impactRating === 'Medium'">Medium</span>
                                <span class="label ml-2 label-default bg-green p5-20"
                                    *ngIf="impactAssessment.impactRating === 'Low'">Low</span>
                            </div>
                        </div> -->
                        <div class="col-lg-3">
                            <label class="control-label fw">Assessment Status</label>
                            <select class="form-control form-control-sm"
                                (change)="updateSectionLastEdited('AssessmentStatus')"
                                [(ngModel)]="impactAssessment.currentAssessmentStatus">
                                <option *ngFor="let option of currentAssessmentStatus" value="{{option}}">{{option}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row ml-2 mt-1" [ngClass]="{ 'div-disabled': !isAssessmentAccessable}">
                        <div class="col-lg-4">
                            <label class="control-label fw">Assessment Last Edited</label>
                            <div class="input-group input-group-sm">
                                <input matInput [matDatepicker]="assessmentLastEdited" disabled
                                    (click)="assessmentLastEdited.open()"
                                    class="form-control form-control-sm border-bottom"
                                    [(ngModel)]="impactAssessment.assessmentLastEdited" name="AssessmentLastEdited" />
                                <div class="input-group-append">
                                    <span class="input-group-text fa fa-calendar" disabled
                                        (click)="assessmentLastEdited.open()"></span>
                                </div>
                            </div>
                            <mat-datepicker #assessmentLastEdited></mat-datepicker>
                        </div>
                        <div class="col-lg-4">
                            <label class="control-label fw">Is Review Required?</label>
                            <select class="form-control form-control-sm"
                                (change)="onReviewRequiredChange($event.target.value)"
                                [(ngModel)]="impactAssessment.isReviewRequired">
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                            </select>
                        </div>
                    </div>

                    <div class="row ml-2 pt-3" [ngClass]="{ 'div-disabled': !isAssessmentAccessable}">

                        <div class="col-lg-12 cursor-pointer" (click)="uploadEvidenceAssessment()">
                            <i class="fa fa-upload"></i>
                            <span class="text-primary ml-1 fw">Upload Evidence - Assessment
                                <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                                    style="font-size: .875rem; line-height: 1.5;"></i>
                            </span>
                            <input id="uploadAssessmentT6" #myFileInputT6
                                (change)="handleFileInput($event.target.files)" type="file" multiple
                                style="display: none" /><br />
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                            <ng-container *ngFor="let docs of impactAssessmentDocument">
                                <div class="file-div text-center" *ngIf="docs.fileType === 14">
                                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isADetailPermission"
                                        (click)="openDeleteModel(docs.id, 'AssessmentT6')"></span>
                                    <span class="cursor-pointer"
                                        (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'AssessmentT6')">
                                        <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-text-o fa-2x"
                                            *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-powerpoint-o fa-2x"
                                            *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'"
                                            aria-hidden="true"></i>
                                    </span>
                                    <div class="data-div">{{docs.fileName}}</div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion id="ReviewDetails" *ngIf="impactAssessment.isReviewRequired">
                <mat-expansion-panel class="ia-expansion-panel pl-2 mt-2">
                    <mat-expansion-panel-header class="ia-mat-panel">
                        <mat-panel-title>
                            <span class="text-header inc-f">
                                Review Details
                            </span>

                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row ml-2 mt-1" [ngClass]="{ 'div-disabled': !isReviewAccessable}">
                        <div class="col-lg-4">
                            <label class="control-label fw">Review/Implementation Team</label>
                            <input type="text" (keyup)="updateSectionLastEdited('Review')"
                                class="form-control form-control-sm" [(ngModel)]="impactAssessment.reviewTeam" />
                        </div>
                        <div class="col-lg-4">
                            <label class="control-label fw">Stakeholder</label>
                            <mat-chip-grid #reviewerList>
                                <mat-chip-row *ngFor="let reviewer of reviewerDD" [selectable]="selectable"
                                    [removable]="removable" (removed)="removeReviewer(reviewer)">
                                    {{reviewer}}
                                    <mat-icon matChipRemove class="clear-icons">clear
                                    </mat-icon>
                                </mat-chip-row>
                                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                                    #trigautoReviewer="matAutocompleteTrigger"
                                    (keydown)="getFilteredData('Reviewer', $event)" #reviewerInput
                                    [formControl]="searchReviewerCntrl" [matAutocomplete]="reviewerAutocomplete"
                                    [matChipInputFor]="reviewerList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                                    (matChipInputTokenEnd)="addReviewer($event)">
                            </mat-chip-grid>
                            <mat-autocomplete #reviewerAutocomplete="matAutocomplete"
                                (optionSelected)="selectedReviewerEvent($event)">
                                <mat-option *ngFor="let reviewer of searchedReviewer" [value]="reviewer.value">
                                    {{reviewer.name}}
                                </mat-option>
                            </mat-autocomplete>
                        </div>

                    </div>
                    <div class="row ml-2 mt-1" [ngClass]="{ 'div-disabled': !isReviewAccessable}">
                        <div class="col-lg-4">
                            <label class="control-label fw">Review Due Date</label>
                            <div class="input-group input-group-sm">
                                <input matInput [matDatepicker]="reviewDueDate"
                                    [attr.disabled]="!isRDetailPermission ? 'disabled' : null"
                                    (click)="reviewDueDate.open()" class="form-control form-control-sm border-bottom"
                                    [(ngModel)]="impactAssessment.reviewDueDate" name="ReviewDueDate"
                                    (dateInput)="updateSectionLastEdited('Review')" />
                                <div class="input-group-append">
                                    <span class="input-group-text fa fa-calendar" *ngIf="isRDetailPermission"
                                        (click)="reviewDueDate.open()"></span>
                                    <span class="input-group-text fa fa-calendar" *ngIf="!isRDetailPermission"></span>
                                </div>
                            </div>
                            <mat-datepicker #reviewDueDate></mat-datepicker>
                        </div>
                        <div class="col-lg-4">
                            <label class="control-label fw">Reviewer Last Edited</label>
                            <div class="input-group input-group-sm">
                                <input matInput [matDatepicker]="reviewLastEdited" disabled
                                    (click)="reviewLastEdited.open()" class="form-control form-control-sm border-bottom"
                                    [(ngModel)]="impactAssessment.reviewLastEdited" name="ReviewLastEdited" />
                                <div class="input-group-append">
                                    <span class="input-group-text fa fa-calendar" disabled
                                        (click)="reviewLastEdited.open()"></span>
                                </div>
                            </div>
                            <mat-datepicker #reviewLastEdited></mat-datepicker>
                        </div>
                        <div class="col-lg-4">
                            <label class="control-label fw">Review Status</label>
                            <select class="form-control form-control-sm"
                                [attr.disabled]="!isRDetailPermission ? 'disabled' : null"
                                (change)="updateSectionLastEdited('ReviewStatus')"
                                [(ngModel)]="impactAssessment.stakeholderStatus">
                                <option *ngFor="let option of reviewStatus" value="{{option}}">{{option}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row ml-2 mt-1" [ngClass]="{ 'div-disabled': !isReviewAccessable}">
                        <div class="col-lg-12">
                            <div>
                                <div class="header-text">

                                    <span class="control-label fw">
                                        Review Details
                                    </span>
                                </div>

                                <app-ck-editor [(childVariable)]="impactAssessment.reviewDetails" id="reviewDetails"
                                    class="f-16" [data]="impactAssessment.reviewDetails"
                                    (keyUpEvent)="updateSectionLastEdited('Review')"></app-ck-editor>
                                <!-- <ckeditor [editor]="Editor" id="reviewDetails" class="f-16" *ngIf="isRDetails"
                    [(ngModel)]="impactAssessment.reviewDetails" (keyup)="updateSectionLastEdited('Review')">
                  </ckeditor> -->
                            </div>
                        </div>
                    </div>

                    <div class="row ml-2 mt-1" [ngClass]="{ 'div-disabled': !isReviewAccessable}">
                        <div class="col-lg-12">
                            <div>
                                <div class="header-text">

                                    <span class="control-label fw">
                                        Stakeholder Impact Assessment
                                    </span>
                                </div>


                                <app-ck-editor [(childVariable)]="impactAssessment.stakeholderImpactAssessment"
                                    id="stakeholderImpactAssessment" class="f-16"
                                    [data]="impactAssessment.stakeholderImpactAssessment"
                                    (keyUpEvent)="updateSectionLastEdited('Review')"></app-ck-editor>
                                <!-- <ckeditor [editor]="Editor" id="reviewDetails" class="f-16" *ngIf="isRDetails"
                      [(ngModel)]="impactAssessment.reviewDetails" (keyup)="updateSectionLastEdited('Review')">
                    </ckeditor> -->
                            </div>
                        </div>
                    </div>
                    <div class="row ml-2 mt-1" [ngClass]="{ 'div-disabled': !isReviewAccessable}">
                        <div class="col-lg-4">
                            <label class="control-label fw">
                                Stakeholder Impact Rating
                                <span class="label label-default bg-default p5-20"
                                    *ngIf="impactAssessment.stakeholderImpactAssessment===''">None</span>
                                <span class="label label-default bg-red p5-20"
                                    *ngIf="impactAssessment.stakeholderImpactAssessment === 'Very High'">Very
                                    High</span>
                                <span class="label ml-2 label-default bg-orange p5-20"
                                    *ngIf="impactAssessment.stakeholderImpactAssessment === 'High'">High</span>
                                <span class="label ml-2 label-default bg-yellow p5-20"
                                    *ngIf="impactAssessment.stakeholderImpactAssessment === 'Medium'">Medium</span>
                                <span class="label ml-2 label-default bg-green p5-20"
                                    *ngIf="impactAssessment.stakeholderImpactAssessment === 'Low'">Low</span>
                            </label>
                            <select class="form-control form-control-sm"
                                [(ngModel)]="impactAssessment.stakeholderImpactAssessment">
                                <option value="Low">Low</option>
                                <option value="Medium">Medium</option>
                                <option value="High">High</option>
                                <option value="Very High">Very High</option>
                            </select>

                        </div>
                        <div class="col-lg-4">
                            <label class="control-label fw">Is Implementation Required?</label>
                            <select class="form-control form-control-sm"
                                [(ngModel)]="impactAssessment.isImplementationRequired"
                                (change)="onImplimentationRequiredChange($event.target.value)">
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                            </select>
                        </div>
                    </div>
                    <div class="row ml-2 pt-3" [ngClass]="{ 'div-disabled': !isReviewAccessable}">

                        <div class="col-lg-3 cursor-pointer" (click)="uploadEvidenceReview()">
                            <i class="fa fa-upload"></i>
                            <span class="text-primary ml-1 fw">Upload Evidence - Review
                                <i *ngIf="isReviewLoader" class="fa fa-circle-o-notch fa-spin"
                                    style="font-size: .875rem; line-height: 1.5;"></i>
                            </span>
                            <input id="uploadReviewT6" #myFileInput2 (change)="handleReviewInput($event.target.files)"
                                type="file" multiple style="display: none" /><br />
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                            <ng-container *ngFor="let docs of impactAssessmentDocument">
                                <div class="file-div text-center" *ngIf="docs.fileType === 15">
                                    <span class="fa fa-trash pull-right delete-docs" *ngIf="isADetailPermission"
                                        (click)="openDeleteModel(docs.id, 'ReviewT6')"></span>
                                    <span class="cursor-pointer"
                                        (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'ReviewT6')">
                                        <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-text-o fa-2x"
                                            *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-powerpoint-o fa-2x"
                                            *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'"
                                            aria-hidden="true"></i>
                                    </span>
                                    <div class="data-div">{{docs.fileName}}</div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion id="ImplementationDetails"
                *ngIf="impactAssessment.isImplementationRequired && impactAssessment.isReviewRequired">
                <mat-expansion-panel class="ia-expansion-panel pl-2 mt-2">
                    <mat-expansion-panel-header class="ia-mat-panel">
                        <mat-panel-title>
                            <span class="text-header inc-f">
                                Implementation Details
                            </span>

                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="row ml-2 mt-1" [ngClass]="{ 'div-disabled': !isReviewAccessable}">
                        <div class="col-lg-4">
                            <label class="control-label fw">Implementation Due Date</label>
                            <div class="input-group input-group-sm">
                                <input matInput [matDatepicker]="implementationDueDate"
                                    (click)="implementationDueDate.open()"
                                    class="form-control form-control-sm border-bottom"
                                    [(ngModel)]="impactAssessment.implementationDueDate" name="ImplementationDueDate"
                                    (dateInput)="updateSectionLastEdited('Implementation')" />
                                <div class="input-group-append">
                                    <span class="input-group-text fa fa-calendar"
                                        (click)="implementationDueDate.open()"></span>

                                </div>
                            </div>
                            <mat-datepicker #implementationDueDate></mat-datepicker>
                        </div>
                        <div class="col-lg-4">
                            <label class="control-label fw">Implementation Last Edited</label>
                            <div class="input-group input-group-sm">
                                <input matInput [matDatepicker]="implementationLastEdited" disabled
                                    (click)="implementationLastEdited.open()"
                                    class="form-control form-control-sm border-bottom"
                                    [(ngModel)]="impactAssessment.implementationLastEdited"
                                    name="ImplementationLastEdited" />
                                <div class="input-group-append">
                                    <span class="input-group-text fa fa-calendar" disabled
                                        (click)="implementationLastEdited.open()"></span>
                                </div>
                            </div>
                            <mat-datepicker #implementationLastEdited></mat-datepicker>
                        </div>
                        <div class="col-lg-4">
                            <label class="control-label fw">Implementation Status</label>
                            <select class="form-control form-control-sm"
                                [attr.disabled]="!isIDetailPermission ? 'disabled' : null"
                                (change)="updateSectionLastEdited('ImplementationStatus')"
                                [(ngModel)]="impactAssessment.implementationStatus">
                                <option *ngFor="let option of implementationStatus" value="{{option}}">{{option}}
                                </option>
                            </select>
                        </div>

                    </div>

                    <div class="row ml-2 mt-1" [ngClass]="{ 'div-disabled': !isReviewAccessable}">
                        <div class="col-lg-12">
                            <div>
                                <div class="header-text">

                                    <span class="control-label fw">
                                        Implementation Details
                                    </span>
                                </div>


                                <app-ck-editor [(childVariable)]="impactAssessment.implementationDetails"
                                    id="implementationDetails" [data]="impactAssessment.implementationDetails"
                                    class="f-16"
                                    (keyUpEvent)="updateSectionLastEdited('Implementation')"></app-ck-editor>
                                <!-- <ckeditor [editor]="Editor" id="implementationDetails" class="f-16" *ngIf="isIDetails"
                    [(ngModel)]="impactAssessment.implementationDetails"
                    (keyup)="updateSectionLastEdited('Implementation')">
                  </ckeditor> -->
                            </div>
                        </div>
                    </div>
                    <div class="row ml-2 pt-3" [ngClass]="{ 'div-disabled': !isReviewAccessable}">

                        <div class="col-lg-3 cursor-pointer" (click)="uploadEvidenceImplementation()">
                            <i class="fa fa-upload"></i>
                            <span class="text-primary ml-1 fw">Upload Evidence - Implementation
                                <i *ngIf="isImplementationLoader" class="fa fa-circle-o-notch fa-spin"
                                    style="font-size: .875rem; line-height: 1.5;"></i>
                            </span>
                            <input id="uploadImplementationT6" #myFileInput3
                                (change)="handleImplementationInput($event.target.files)" type="file" multiple
                                style="display: none" /><br />
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
                            <ng-container *ngFor="let docs of impactAssessmentDocument">
                                <div class="file-div text-center" *ngIf="docs.fileType === 16">
                                    <span class="fa fa-trash pull-right delete-docs"
                                        (click)="openDeleteModel(docs.id, 'ImplementationT6')"></span>
                                    <span class="cursor-pointer"
                                        (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'ImplementationT6')">
                                        <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-text-o fa-2x"
                                            *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'"
                                            aria-hidden="true"></i>
                                        <i class="fa fa-file-powerpoint-o fa-2x"
                                            *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'"
                                            aria-hidden="true"></i>
                                    </span>
                                    <div class="data-div">{{docs.fileName}}</div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>


<div class="card" *ngIf="!isAuthorised">
    <div class="crad-body p-2">
        <div>You are not authorised to see this impact assessment.</div>
    </div>
</div>